var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckSquareFilled = function SvgIconCheckSquareFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.815 10.474a1 1 0 0 0-1.38-1.448l-4.812 4.591-2.057-1.965a1 1 0 0 0-1.382 1.446l2.747 2.625a1 1 0 0 0 1.381 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 2.75A1.75 1.75 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75zm.25 16.5V4.75h14.5v14.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCheckSquareFilled;